import { trackElementBox } from 'shared/javascripts/util/element_box'

interface PlayerTimeEvent extends Event {
  time: number
  isAd: boolean
}

up.compiler('[data-video-next-step-selector]', (element: HTMLElement, data: { time: number }) => {
  const AUTOSELECT_DURATION_IN_MS = 10_000

  let visible = false
  let dismissed = false
  let adRunning = false
  let autoselectTimer: number | undefined
  let stopTrackingContent: (() => void) | undefined

  const startsAt = data.time
  const autoselectOption = element.querySelector<HTMLElement>(
    '[data-video-next-step-selector--autoselect]',
  )
  const progressBar = autoselectOption?.querySelector<HTMLElement>(
    '.video-next-step-banner--option-card-autoselect-progress-bar',
  )
  const playerContainer = element
    .closest('.video-layout-learning--body')
    ?.querySelector<Element>('.player--container')
  const contentContainer = element.closest<HTMLElement>('.video-layout-learning--content')

  up.on(element, 'up:click', '[data-video-next-step-selector--pause-and-close]', () => {
    up.emit('app:main-player:pause')
    dismissBanner()
  })

  up.on(element, 'up:click', '[data-video-next-step-selector--close]', () => {
    dismissBanner()
  })

  function showBanner(): void {
    if (visible || dismissed) return

    visible = true
    element.classList.add('-visible')
    up.animate(element, 'move-from-bottom')
    startAutoselect()
  }

  function hideBanner(): void {
    if (!visible) return

    visible = false
    stopAutoselect()
    element.classList.remove('-visible')
  }

  function dismissBanner(): void {
    if (dismissed) return

    dismissed = true
    stopAutoselect()
    const animationPromise = up.animate(element, 'move-to-bottom')
    animationPromise.then(() => {
      element.classList.remove('-visible')
    })
  }

  function startAutoselect(): void {
    if (!autoselectOption) return

    stopAutoselect()

    progressBar!.style.setProperty('--autoselect-duration-ms', String(AUTOSELECT_DURATION_IN_MS))
    progressBar!.classList.remove('-running')
    progressBar!.getBoundingClientRect()
    progressBar!.classList.add('-running')

    autoselectTimer = window.setTimeout(() => {
      if (visible && !dismissed) {
        up.follow(autoselectOption)
      }
    }, AUTOSELECT_DURATION_IN_MS)
  }

  function stopAutoselect(): void {
    if (autoselectTimer) {
      window.clearTimeout(autoselectTimer)
      autoselectTimer = undefined
    }

    if (progressBar) {
      progressBar.classList.remove('-running')
    }
  }

  function onPlayerTime(event: PlayerTimeEvent): void {
    if (dismissed) return

    const currentTime = event.time

    if (currentTime >= startsAt && !adRunning) {
      showBanner()
    } else {
      hideBanner()
    }
  }

  function onAdStarted(): void {
    adRunning = true
    hideBanner()
  }

  function onAdFinished(): void {
    adRunning = false
  }

  if (!playerContainer) return

  up.on(playerContainer, 'app:player:time', onPlayerTime)
  up.on(playerContainer, 'app:player:adStarted', onAdStarted)
  up.on(playerContainer, 'app:player:adFinished', onAdFinished)

  if (contentContainer) {
    stopTrackingContent = trackElementBox(contentContainer, element, '--video-next-step')
  }

  return () => {
    stopAutoselect()
    up.off(playerContainer, 'app:player:time', onPlayerTime)
    up.off(playerContainer, 'app:player:adStarted', onAdStarted)
    up.off(playerContainer, 'app:player:adFinished', onAdFinished)
    stopTrackingContent?.()
  }
})
